module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.9@core-js/library/modules/_library.js
// module id = X1tf
// module chunks = 0